/**
 * Accepts a returnUrl only if it is a path inside this app, so Login cannot redirect a rep to another
 * site. Rejects other hosts, `//host`, `/\host` (browsers read it as `//host`) and schemes like `javascript:`.
 */
export function safeReturnUrl(value: string | null | undefined): string | null {
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }

  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return null;
  }

  // Control characters let a browser read the path as something else.
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(value)) {
    return null;
  }

  // Returning to Login would only loop.
  if (/^\/login(?:[/?#]|$)/i.test(value)) {
    return null;
  }

  return value;
}
